import { createElement } from "react"
import { type RouteObject, replace } from "react-router"
import { AppErrorPage } from "@/pages/ErrorPage"
import { routeTree } from "../route-tree"
import { lazyLoadComponent } from "../utils"
import { rootRoutes } from "./root"

export const getRoutes = () => {
  const routes: RouteObject[] = [...rootRoutes]

  // Should always be the last route
  routes.push({
    path: routeTree.catchAll.segment,
    lazy: lazyLoadComponent(() => import("@/pages/NotFoundPage")),
    loader: () => replace(routeTree.notFound.path()),
  })

  return [
    {
      errorElement: createElement(AppErrorPage),
      children: routes,
    },
  ]
}
